module.exports = __webpack_public_path__ + "img/gem.752378f7.png";